import React, { CSSProperties } from 'react';

interface ProgressBarProps {
  /**
   * Text label to display inside the progress bar
   */
  label?: string;
  /**
   * Optional custom styles
   */
  style?: CSSProperties;
  /**
   * Optional CSS class name
   */
  className?: string;
}

const ProgressBar: React.FC<ProgressBarProps> = ({
  label,
  style,
  className,
}) => {
  // Bootstrap 3 .progress container styles (exact)
  const containerStyles: CSSProperties = {
    height: '20px',
    marginBottom: '20px',
    overflow: 'hidden',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    boxShadow: 'inset 0 1px 2px rgba(0,0,0,.1)',
    ...style,
  };

  // Bootstrap 3 .progress-bar styles (exact) with striped and active
  const barStyles: CSSProperties = {
    float: 'left',
    width: '100%',
    height: '100%',
    fontSize: '12px',
    lineHeight: '20px',
    color: '#fff',
    textAlign: 'center',
    backgroundColor: '#337ab7',
    boxShadow: 'inset 0 -1px 0 rgba(0,0,0,.15)',
    transition: 'width .6s ease',
    // Bootstrap 3 striped background
    backgroundImage:
      'linear-gradient(45deg,rgba(255,255,255,.15) 25%,transparent 25%,transparent 50%,rgba(255,255,255,.15) 50%,rgba(255,255,255,.15) 75%,transparent 75%,transparent)',
    backgroundSize: '40px 40px',
    // Bootstrap 3 active animation
    animation: 'progress-bar-stripes 2s linear infinite',
  };

  // Bootstrap 3 @keyframes progress-bar-stripes (exact)
  const keyframes = `
    @keyframes progress-bar-stripes {
      from { background-position: 40px 0; }
      to { background-position: 0 0; }
    }
  `;

  return (
    <>
      <style>{keyframes}</style>
      <div className={className} style={containerStyles}>
        <div
          style={barStyles}
          role="progressbar"
          aria-valuenow={100}
          aria-valuemin={0}
          aria-valuemax={100}
        >
          {label}
        </div>
      </div>
    </>
  );
};

export default ProgressBar;
